import { lazy } from "react";
import { setStudioView } from "../workspace/studio-views";
import type { AnimationNextStepProps } from "./AnimationNextStep";
const AnimationNextStep = lazy(() => import("./AnimationNextStep").then(module => ({ default: module.AnimationNextStep })));
import type { MotionModelsProps } from "./MotionModels";
const MotionModelPanel = lazy(() => import("./MotionModels").then(module => ({ default: module.MotionModelPanel })));
const SceneMotionModel = lazy(() => import("./MotionModels").then(module => ({ default: module.SceneMotionModel })));
export function mountAnimationNextStep(
  slot: HTMLElement,
  props: AnimationNextStepProps,
) {
  setStudioView("animation-next", `animation-next:${props.project.id}`, <AnimationNextStep {...props} />);
}
export function mountMotionModels(slot: HTMLElement, props: MotionModelsProps) {
  setStudioView("motion-models", `motion-models:${props.project.id}`, <MotionModelPanel {...props} />);
}
export function mountSceneMotionModel(
  slot: HTMLElement,
  props: MotionModelsProps & { sceneId: string },
) {
  setStudioView("scene-motion-model", `scene-motion-model:${props.project.id}:${props.sceneId}`, <SceneMotionModel {...props} />);
}
